import axios from 'axios';

const getBaseUrl = () => {
  if (process.env.REACT_APP_ENV === 'local') {
    return 'http://localhost:8888';
  }
  if (process.env.REACT_APP_ENV === 'development') {
    return 'https://dev-api.nanumprice.kr';
  }
  return 'https://api.nanumprice.kr';
};

const base = getBaseUrl();

const doAdminRequest = async ({ method, url, params }) => {
  const token =
    localStorage.getItem('adminToken') || localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json; charset=utf-8',
    Authorization: `Bearer ${token}`,
  };

  const getQueryParams = (params) => {
    if (!params) return '';
    return Object.entries(params)
      .filter(([, v]) => v !== undefined && v !== null && v !== '')
      .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
      .join('&');
  };

  let ret;
  if (method === 'get') {
    ret = await axios.get(`${url}?${getQueryParams(params)}`, { headers });
  } else if (method === 'post') {
    ret = await axios.post(url, params, { headers });
  } else if (method === 'delete') {
    ret = await axios.delete(`${url}?${getQueryParams(params)}`, { headers });
  }
  return ret.data;
};

// 어드민 로그인
export const postAdminSignin = async (params) => {
  const ret = await axios.post(`${base}/api/admin/account/signin`, params, {
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
  });
  return ret.data;
};

// 대시보드
export const getDashboard = () =>
  doAdminRequest({ method: 'get', url: `${base}/api/admin/manage/dashboard` });

// 유저
export const getAdminUsers = (params) =>
  doAdminRequest({
    method: 'get',
    url: `${base}/api/admin/manage/users`,
    params,
  });

// 결제
export const getAdminPayments = (params) =>
  doAdminRequest({
    method: 'get',
    url: `${base}/api/admin/manage/payments`,
    params,
  });

// 이메일 발송 내역
export const getAdminEmailLogs = (params) =>
  doAdminRequest({
    method: 'get',
    url: `${base}/api/admin/manage/email-logs`,
    params,
  });

// 급매 알림 스냅샷
export const getAdminAlertSnapshots = (params) =>
  doAdminRequest({
    method: 'get',
    url: `${base}/api/admin/manage/alert-snapshots`,
    params,
  });

export const getAdminAlertSnapshot = (id) =>
  doAdminRequest({
    method: 'get',
    url: `${base}/api/admin/manage/alert-snapshots/${id}`,
  });

// 단지
export const postAdminComplex = (params) =>
  doAdminRequest({
    method: 'post',
    url: `${base}/api/admin/manage/complex`,
    params,
  });

export const postRegisterBldg = async (naverUrl) => {
  const token =
    localStorage.getItem('adminToken') || localStorage.getItem('token');
  const ret = await axios.post(
    `${base}/api/data/analysis/estate/bldg?url=${encodeURIComponent(naverUrl)}`,
    {},
    {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return ret.data;
};

export const getAdminComplexList = (params) =>
  doAdminRequest({
    method: 'get',
    url: `${base}/api/admin/manage/complex`,
    params,
  });

// 크롤링 스케줄
export const getRegionSchedule = () =>
  doAdminRequest({
    method: 'get',
    url: `${base}/api/config/region`,
  });

export const postRegionSchedule = (params) =>
  doAdminRequest({
    method: 'post',
    url: `${base}/api/config/region`,
    params,
  });

// 유저 수동 등록
export const postCreateUser = (params) =>
  doAdminRequest({
    method: 'post',
    url: `${base}/api/admin/manage/users`,
    params,
  });

// 어드민 권한 변경
export const postToggleAdmin = (userId, isAdmin) =>
  doAdminRequest({
    method: 'post',
    url: `${base}/api/admin/manage/users/${userId}/admin`,
    params: { isAdmin },
  });

// 유저 휴면처리
export const deleteAdminUser = (email) =>
  doAdminRequest({
    method: 'delete',
    url: `${base}/api/admin/account/delete`,
    params: { email },
  });

// 유저 휴면해제
export const postCancelDeleteUser = (email) =>
  doAdminRequest({
    method: 'post',
    url: `${base}/api/admin/account/cancel/delete`,
    params: { email },
  });

// 결제 환불
export const postRefundPayment = (paymentId, params) =>
  doAdminRequest({
    method: 'post',
    url: `${base}/api/admin/manage/payments/${paymentId}/refund`,
    params,
  });

// 유저 플랜 만료일 연장
export const postExtendUserPlan = (userId, params) =>
  doAdminRequest({
    method: 'post',
    url: `${base}/api/admin/manage/users/${userId}/extend-plan`,
    params,
  });

// 유저 플랜 수동 변경
export const postUpdateUserPlan = (userId, params) =>
  doAdminRequest({
    method: 'post',
    url: `${base}/api/admin/manage/users/${userId}/plan`,
    params,
  });

// 전고점 수동 설정
export const getAdminPeakPrices = (params) =>
  doAdminRequest({
    method: 'get',
    url: `${base}/api/admin/manage/peak-prices`,
    params,
  });

export const postAdminPeakPrice = (params) =>
  doAdminRequest({
    method: 'post',
    url: `${base}/api/admin/manage/peak-prices`,
    params,
  });

export const deleteAdminPeakPrice = (id) =>
  doAdminRequest({
    method: 'delete',
    url: `${base}/api/admin/manage/peak-prices/${id}`,
  });

// 실거래가 CSV 업로드
export const postUploadRealPrice = async ({ file, type, encoding }) => {
  const token =
    localStorage.getItem('adminToken') || localStorage.getItem('token');
  const form = new FormData();
  form.append('file', file);
  form.append('type', type);
  if (encoding) form.append('encoding', encoding);

  const res = await axios.post(`${base}/api/admin/real-price/upload`, form, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    timeout: 10 * 60 * 1000,
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
  });
  return res.data;
};
